"use client"

import { StatusFilterOption } from "@anaconda/core/nft/search/types"
import { Trans } from "@lingui/react/macro"
import {
  Label,
  RadioGroup,
  RadioGroupItem,
} from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { NftFiltersMoleculeReatom } from "./store.reatom"

const FILTER_OPTIONS = [
  { type: StatusFilterOption.ALL, label: <Trans>All</Trans> },
  { type: StatusFilterOption.BUY_NOW, label: <Trans>Buy Now</Trans> },
] as const

export const StatusFilter = reatomComponent(() => {
  const { statusFilter } = useMolecule(NftFiltersMoleculeReatom)
  const status = statusFilter()

  return (
    <RadioGroup
      className="flex flex-col gap-3"
      value={status}
      onValueChange={(value) => statusFilter.set(value as StatusFilterOption)}
    >
      {FILTER_OPTIONS.map(({ type, label }) => (
        <div key={type} className="flex items-center gap-3">
          <RadioGroupItem value={type} id={type} />
          <Label className="cursor-pointer text-md" htmlFor={type}>
            {label}
          </Label>
        </div>
      ))}
    </RadioGroup>
  )
}, "StatusFilter")
